<template>
    <div class="devices-list__block" v-if="deviceData" @click="openChart">
        <device-status :device="deviceData" :showLocation="showLocation"/>
        <v-layout row class="devices-list__block__title">
            <device-title :device="deviceData"></device-title>
            <v-flex class="btn-block">
                <device-favorite :device="deviceData"></device-favorite>
            </v-flex>
        </v-layout>
        <div class="d-inline-flex align-center main-text mt-3" v-if="deviceData.state">
            Освещённость:
            <span class="main-text__medium mx-1"> {{ deviceData.state.illuminance }} лк, </span>
            <div
                v-if="deviceData.state.illuminance < 21"
                v-html="require('!html-loader!@/assets/icons/illumination/moon_icon.svg')"
                class="d-inline-flex size-22"
            />
            <div
                v-else-if="deviceData.state.illuminance > 20 && deviceData.state.illuminance < 101"
                v-html="require('!html-loader!@/assets/icons/illumination/cloudy_icon.svg')"
                class="d-inline-flex size-22"
            />
            <div
                v-else-if="deviceData.state.illuminance > 101"
                v-html="require('!html-loader!@/assets/icons/illumination/sun_icon.svg')"
                class="d-inline-flex size-22"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "IlluminationDevice",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
        };
    },
    created() {
        this.deviceData = this.device;
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
            }
        },
    },
    methods: {
        openChart() {
            if (!this.deviceData.is_action) {
                this.$router.push({ name: 'illuminancePage', query: {device: this.deviceData.uid}});
            }
        },
    },
}
</script>
